import { render, staticRenderFns } from "./GroupStatus.vue?vue&type=template&id=30416b14"
import script from "./GroupStatus.vue?vue&type=script&lang=js"
export * from "./GroupStatus.vue?vue&type=script&lang=js"
import style0 from "./GroupStatus.vue?vue&type=style&index=0&id=30416b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports